import MicroTextSubPage from 'components/MapoAdministration/components/Content-Management/MicroTextSubPage';

const ScreenMicroTextSubPage = () => <MicroTextSubPage />;

export default ScreenMicroTextSubPage;
